module.exports = __webpack_public_path__ + "static/media/iconepansement.f75cbd79.png";